import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class DragAndDropState {
  onAdd;
  onEdit;
  onRemove;
  onMove;
  onDuplicate;

  models = [];

  constructor(models, onAdd, onEdit, onRemove, onMove, onDuplicate) {
    makeAutoObservable(this);

    this.models = models;
    this.onAdd = onAdd;
    this.onEdit = onEdit;
    this.onRemove = onRemove;
    this.onMove = onMove;
    this.onDuplicate = onDuplicate;
  }

  moveModel(fromIndex, toIndex) {
    const dragField = this.sortedModels[fromIndex];
    const hoverField = this.sortedModels[toIndex];

    const dragOrder = dragField.order;
    const hoverOrder = hoverField.order;
    dragField.merge({order: hoverOrder});
    hoverField.merge({order: dragOrder});

    if (this.onMove) {
      this.onMove(fromIndex, toIndex);
    }
  }

  addModel() {
    const order = this.models.length;
    this.onAdd(order);
  }

  editModel(model) {
    this.onEdit(model);
  }

  duplicateModel(model) {
    const laterModels = _.filter(this.models, otherModel => otherModel.order > model.order);
    for (const laterModel of laterModels) {
      laterModel.order += 1;
    }

    this.onDuplicate(model, model.order + 1);
  }

  removeModel(model) {
    const result = this.onRemove(model);

    if (result !== false) {
      const laterModels = _.filter(this.models, m => m.order > model.order);
      for (const m of laterModels) {
        m.order -= 1;
      }
    }
  }

  get sortedModels() {
    return _.sortBy(
      this.models,
      'order'
    );
  }

  get hasLinks() {
    return this.onRemove || this.onEdit || this.onDuplicate;
  }
}

export default DragAndDropState;
